import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

export interface MenuData {
  "Category-Icon"?: string | null;
  "Category-Icon-Color-Class"?: string | null;
  "Category-Text"?: string | null;
  "Category-Value"?: string | null;
  "Group-Icon"?: string | null;
  "Group-Text"?: string | null;
  "Nav-Item-Text"?: string | null;
  "Badge text"?: string | null;
  Route?: string | null;
  "Description for html meta-tag"?: string | null;
}

@Injectable({
  providedIn: "root",
})
export class NavigationService {
  private http = inject(HttpClient);

  constructor() {}

  getNavigation(url:string): Observable<MenuData[]> {
    return this.http.get<MenuData[]>(url);
  }
}
